import {Component, OnInit} from '@angular/core';
import { ConfirmationService } from 'src/app/amena/services/confirmation.service';
import { ShoppingCartService } from 'src/app/amena/services/shopping-cart-service';

@Component({
    selector: 'app-cliente',
    templateUrl: './cliente.component.html',
    styleUrls: ['./cliente.component.css', '../../../../../assets/css/amena-theme.css'],
    standalone: false
})
export class ClienteComponent implements OnInit {
    public date = null;
    public contractId = null;
    public user_data = null;
    public muestraComentarios: boolean;
    public tipoAlta = null;

    constructor(
        private confirmationService: ConfirmationService, 
        private shoppingCartService: ShoppingCartService
    ) { }

    ngOnInit(): void {
        this.confirmationService.getDataClient()
            .subscribe((data) => {
                if (data) {
                    this.user_data = data;
                }
            });

        this.confirmationService.getDateClient()
            .subscribe(data => {
                if (data) {
                    this.date = data;
                }
            });

        this.confirmationService.getContractId()
            .subscribe(data => {
                if (data) {
                    this.contractId = data;
                }
            });

        this.confirmationService.getMuestraComentarios()
            .subscribe(data => {                
                if (data) {
                    this.muestraComentarios = data;
                }
            });

        this.confirmationService.getTipoAlta()
            .subscribe(data => {
                if (data) {
                    this.tipoAlta = data;
                }
            });
    }

    getShoppingCart() {
        return this.shoppingCartService.getShoppingCart();
    }

    getAdditionalLines() {
        let num = -1;
        for (const item of this.getShoppingCart().getItems()) {
            for (const concept of item.concepts) {
                if (concept.type === 'rate') {
                    num += 1;
                }
            }
        }
        return num;
    }

    msisdnMainLine(): string {
        let items = this.getShoppingCart().getItems();
        let msisdnMainLine = '';
        if (items && items.length) {
            msisdnMainLine = items[0].portability;
        }
        return msisdnMainLine;
    }

}
